(function() {
  'use strict';

  const trackedEvents = new Set();
  const trackQueue = new Set();
  let trackingTimeout = null;
  let sharedObserver = null;

  function sendTracking() {
    if (trackQueue.size === 0) return;

    const slugsToTrack = Array.from(trackQueue).filter(slug => !trackedEvents.has(slug));
    trackQueue.clear();
    if (slugsToTrack.length === 0) return;

    slugsToTrack.forEach(slug => trackedEvents.add(slug));

    if (navigator.sendBeacon) {
      const formData = new FormData();
      slugsToTrack.forEach(slug => formData.append('event_slugs[]', slug));
      navigator.sendBeacon('/track_impression', formData);
    } else {
      fetch('/track_impression', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content || ''
        },
        body: JSON.stringify({ event_slugs: slugsToTrack }),
        keepalive: true
      }).catch(() => {});
    }
  }

  function queueTracking(eventSlug) {
    trackQueue.add(eventSlug);
    if (trackingTimeout) clearTimeout(trackingTimeout);
    trackingTimeout = setTimeout(sendTracking, 300);
  }

  function extractEventSlug(element) {
    const href = element.getAttribute('href');
    if (href) {
      const match = href.match(/\/(?:events\/)?([^\/\?#]+)$/);
      if (match) return match[1];
    }
    return element.dataset.eventSlug;
  }

  function getObserver() {
    if (sharedObserver) return sharedObserver;
    sharedObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          const eventSlug = extractEventSlug(entry.target);
          if (eventSlug && !trackedEvents.has(eventSlug)) {
            queueTracking(eventSlug);
          }
        }
      });
    }, { root: null, rootMargin: '50px', threshold: 0.5 });
    return sharedObserver;
  }

  function observeCards(container) {
    const scope = container || document;
    const cards = scope.querySelectorAll('.ds-event-card, .event-item a[href*="/"]');
    if (cards.length === 0) return;

    const observer = getObserver();
    cards.forEach(card => {
      const eventSlug = extractEventSlug(card);
      if (eventSlug && !trackedEvents.has(eventSlug)) {
        observer.observe(card);
      }
    });
  }

  function setupImpressionTracking() {
    observeCards(null);
  }

  // Exposed so discover.js can observe cards appended via "show more"
  window.observeNewEventCards = observeCards;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupImpressionTracking);
  } else {
    setupImpressionTracking();
  }

  if (typeof Turbolinks !== 'undefined') {
    document.addEventListener('turbolinks:load', setupImpressionTracking);
  }
  if (typeof Turbo !== 'undefined') {
    document.addEventListener('turbo:load', setupImpressionTracking);
  }
})();
